<template>
  <div class="attendee-sidebar">
    <router-link
      v-if="attendee?.logo_url"
      :to="homePageLink"
      class="attendee-sidebar__logo"
    >
      <img :src="attendee?.logo_url" alt="Event Logo" width="150" />
    </router-link>

    <div class="attendee-sidebar__menu">
      <common-menu direction="column" />
    </div>

    <div
      v-if="showBanner"
      class="attendee-sidebar__banner"
    >
      <a
        href="http://nbcc.org/"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Open NBCC website"
      >
        <img src="/images/attendee-dashboard/ACES-Attendee-Dashboard.jpg" alt="NBCC" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonMenu from "../CommonMenu";
import { ROUTES } from "../../../router";

export default {
  components:{
    CommonMenu
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee']),

    showBanner() {
      return this.attendee.organization_id === 4256;
    },
  },
  data(){
    return {
      homePageLink: ROUTES.MAIN_LAYOUT.replace(':attendeeId', this.$route.params.attendeeId),
      attendeeId: this.$route.params.attendeeId,
    }
  },
}
</script>

<style scoped lang="scss">
.attendee-sidebar {
  //height: calc(100vh - var(--attendee-gap-lg) - var(--attendee-gap-lg));
  height: auto;
  min-height: calc(100vh - var(--attendee-gap-lg) - var(--attendee-gap-lg));
  display: block;
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  box-shadow: var(--attendee-box-shadow);
  position: sticky;
  top: var(--attendee-gap-lg);
  margin-top: var(--attendee-gap-lg);
  //display: flex;
  //flex-direction: column;
  //overflow: hidden;

  &__logo {
    display: block;
    z-index: 99;
    position: relative;
    padding: var(--attendee-gap-md);
    text-align: center;

    img {
      width: 80%;
      height: auto;
      max-width: 100%;
      object-fit: cover;
    }
  }

  &__menu {
    //flex: 1 1 auto;
    //min-height: 0;
    //overflow: auto;
  }

  &__banner {
    position: static;
    flex-shrink: 0;
    //margin-top: var(--attendee-gap-md);
    padding: var(--attendee-gap-md);
    text-align: center;
    z-index: 1;

    a {
      display: block;
    }

    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      display: block;
      border-radius: 8px;
      object-fit: cover;
    }
  }
}
</style>
